import React from "react";
import { useDrop } from "react-dnd";

export type WithUseDropProps = {
  onDrop?: () => void;
  name: string;
  children: React.ReactNode;
  className?: string;
};

export const WithUseDrop: React.FC<WithUseDropProps> = ({ onDrop, name, children, className }) => {
  const [{}, dropRef] = useDrop({
    accept: name,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
    drop: () => {
      if (onDrop) {
        onDrop();
      }
    },
  });

  return (
    <div className={className} ref={dropRef}>
      {children}
    </div>
  );
};
